import { ApolloLink, HttpLink, ApolloClient, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { getPreviewToken } from './previewTokenStore';
import { getBaseUrl } from '../helpers/base_url_helper';

export const UNAUTHENTICATED = 'UNAUTHENTICATED';
export const INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR';

const CORS = 'cors';

// TODO: clean this module up and double-check authz handling

// Breaking change
// https://www.apollographql.com/docs/react/migrating/apollo-client-3-migration/#breaking-cache-changes
// Possible solution
// https://www.apollographql.com/docs/react/data/fragments/#defining-possibletypes-manually
export const cache = new InMemoryCache({
  possibleTypes: {
    SurveyElementQuestion: [
      'SurveyElementMessage',
      'SurveyElementQuestionOptions',
      'SurveyElementQuestionText',
      'SurveyElementQuestionScale',
    ],
  },
});

export const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach((err) => {
      console.log(
        `[GraphQL error]: Message: ${err.message}, Location: ${JSON.stringify(err.locations, null, 2)}, Path: ${
          err.path
        }`,
      );

      switch (err.extensions.code) {
        case UNAUTHENTICATED: {
          const headers = operation.getContext().headers;

          operation.setContext({
            headers: {
              ...headers,
              authorization: '', // getNewToken()
            },
          });

          return forward(operation);
        }
        case INTERNAL_SERVER_ERROR:
          // sessionStorage.clear();
          // localStorage.clear();
          // operation.getContext().cache.reset();
          return forward(operation);
        default:
          break;
      }
    });
  }

  if (networkError) {
    console.log(`[Network error]: Error: ${networkError}`);
    // sessionStorage.clear();
    // localStorage.clear();
    // operation.getContext().cache.reset();
    return forward(operation);
  }
});

export const httpLink = new HttpLink({
  uri: getBaseUrl(),
});

export const initialData = {};

// Apollo client singleton.
let clientInstance = null;

export const createClient = () => {
  if (!clientInstance) {
    /**
     * Attaches the admin JWT to requests made during survey preview mode.
     *
     * When an HR Admin opens a survey preview from the Question Builder, the
     * admin client app passes its JWT to this tab via postMessage (see
     * usePreviewToken.js). That token is held in memory by previewTokenStore.js
     * and is needed to authenticate the previewEmployeeSearch query — the only
     * survey-app endpoint that requires a real user session. All other survey
     * endpoints are public (authenticated by the survey hash code alone).
     *
     * For non-preview sessions getPreviewToken() returns null, so the header
     * is never set and all requests go through unchanged.
     */
    const previewAuthLink = new ApolloLink((operation, forward) => {
      const token = getPreviewToken();

      if (token) {
        operation.setContext(({ headers = {} }) => ({
          headers: { ...headers, Authorization: `Bearer ${token}` },
        }));
      }
      return forward(operation);
    });

    clientInstance = new ApolloClient({
      connectToDevTools: true,
      link: previewAuthLink.concat(errorLink).concat(httpLink),
      cache,
      fetchOptions: {
        mode: CORS,
      },
      defaults: {
        ...initialData,
      },
      // typeDefs,
    });
  }

  return clientInstance;
};

// By default, the client is returned. Other functions are exported for convenience.
export default createClient();
